<template>
  <div v-if="problem">
    <h2 
    class="main__text"
      style="
        text-align: center;
        margin-bottom: 2px;
        display: flex;
        flex-direction: column;
        align-items: center;
      "
    >

      <span class="header__text" >
        {{ headerTxt }}

      
          <span
            class="circle"
            :style="{ backgroundColor: priority.color }"
          ></span>
      
      </span>

    
    </h2>

    <h4 style="text-align: center">
      {{ problemStructureTxt }}
  <!--     <span v-if="!problem.representation" style="color: red"
        >(Nəzarətçi təyin edilməyib)</span
      > -->
      <!-- <a-button v-if="problem.prevProblemId!=null" @click="showPrevProblem">Əvvəlki baxın</a-button> -->
      <a
        v-if="problem.prevProblemId != null"
        style="text-decoration: underline; color: blue"
        :href="'/problems/' + problem.prevProblemId"
        >Əvvəlki şikayət</a
      >
    </h4>
    <!--
       <h4 v-if="!txtEditMode" class="problem-text">
      {{ problem.text }}
      <a-button
        v-if="currentStep.canUpdateProblemInfo"
        type="link"
        class="txt-edit"
        icon="edit"
        @click="txtEditMode = true"
      />
    </h4>
    <div v-if="txtEditMode" style="position:relative;margin-bottom:2px;">
      <a-input
        v-model="title"
        style="text-align:center;margin:auto 0;display:inline-block;"
      />
      <a-button
        type="primary"
        style="position: absolute;right:1px"
        @click="saveTxt"
        :loading="loading"
        >Saxlasss</a-button
      >
    </div> -->

    <detail-modal
      :visible="modalVisible"
      :problemOb="prevProblem"
      @afterClose="handleModalClose"
    ></detail-modal>
  </div>
</template>

<script>
import DetailModal from "@/components/pages/Modals/DetailModal/index";
import mixin from "@/mixins/index";
import { URL, apiCall } from "@/utils/api";
export default {
  name: "ProblemHeader",
  mixins: [mixin],
  props: { problem: Object },
  components: {
    "detail-modal": DetailModal,
  },
  data() {
   
    return {
      modalVisible: false,
      prevProblem: null,
      txtEditMode: false,
      title: this.problem.text,
      priorityColor: null,
      loading: false,
    };
  },
  computed: {
    problemStructureTxt: function () {
      return (
        (this.problem.executive
          ? this.problem.executive.name 
          : "Yerli icra hakimiyyəti orqanı seçilməlidir") +
        (this.problem.representation ? this.problem.representation.name : "")
      );
    },
    headerTxt: function () {
      return (
        "Şikayət nömrəsi: " +
        (this.problem.number ? this.problem.number.pad(6) : "")
      );
    },
    headerTxtSecondary: function () {
      return `Müraciət sayı: ${this.problem.appealCount}`;
    },
  },
  methods: {
    showPrevProblem() {
      // this.prevProblem = { id: this.problem.prevProblemId };
      // this.modalVisible = true;
      window.location.href = "/problems/" + this.problem.prevProblemId;
    },
    handleModalClose() {
      this.modalVisible = false;
    },
    saveTxt() {
      if (this.title.trim() === this.problem.text) {
        this.txtEditMode = false;
        return;
      }
      this.loading = true;
      apiCall({
        url:
          URL[process.env.NODE_ENV].service_api +
          `problems/${this.problem.id}/info`,
        method: "PUT",
        data: { title: this.title },
      })
        .then((response) => {
          this.loading = false;
          if (!response.data.error) {
            this.problem.text = this.title;
            this.txtEditMode = false;
            return;
          }
          this.$message.error(response.data.error.message);
        })
        .catch((err) => {
          this.$message.error("Xəta baş verdi");
          console.log(err);
          this.loading = false;
        });
    },
  },
  created() {
    this.priority = this.priorityLevels.find(
      (item) => item.name === this.problem.priorityLevel
    );
  },
};
</script>

<style lang="scss" scoped>
.circle {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 10px;
  vertical-align: middle;
}
.txt-edit {
  opacity: 0;
  transition: opacity 0.4s;
}

.problem-text {
  text-align: center;
  margin-bottom: 2px;
  &:hover .txt-edit {
    opacity: 1;
  }
}

@media only screen and (max-width: 1100px) {
  .header__text{
    margin-top: 36px !important;
  }
  .main__text{
    text-align: left;
  }
}
</style>
